import {
    DAYS_BEFORE_EXPIRE_KEY,
    IAuthenticationPublicWebServiceClient, IS_FIRST_CONNECTION_KEY,
    UserInformations
} from "./../../resources/auth/resources.auth";
import { Injectable, Inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { CerbaAuthService } from "../../services/auth.service";
import { CerbaCookieService } from "../../services/cerbacookie.service";
import { CookieConstantes } from "../../constantes/cookie.constantes";
import * as lodash from "lodash";

import { ICorrespondantClient } from "./../../resources/correspondant.service";
import { IUserInformationsClient } from '../../resources/userInformation.service';
import { CorrespondantStore } from "./../../store/correspondant.store";
import { UserStore } from "./../../store/user.store";
import { CORRESPONDANT_CLIENT, USER_INFO_CLIENT } from "../../resources/tokens/injectionTokens";
@Injectable()
export class EnsureUserAuthGuard implements CanActivate {

    constructor(private cookieService: CerbaCookieService,
        private cerbaAuthService: CerbaAuthService,
        private auth: IAuthenticationPublicWebServiceClient,
        @Inject(CORRESPONDANT_CLIENT) private correspondantWebservice: ICorrespondantClient,
        @Inject(USER_INFO_CLIENT) private userInformationsWebService: IUserInformationsClient,
        private correspondantStore: CorrespondantStore,
        private userStore: UserStore) {
    }

    isOriginalAuthentication() {
        let currentAuthenticationCookie = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
        let originalAuthenticationCookie = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_ORIGINAL);

        return currentAuthenticationCookie && (originalAuthenticationCookie == null || originalAuthenticationCookie == '');
    }

    async canActivate(route: ActivatedRouteSnapshot) {

        // check if there is a token in the url
        let token = this.extractToken();
        if (token) {
            const authenticate = await this.valideToken(token).toPromise();
            if (!authenticate) {
                this.redirectWhenNoAuth();
                return false;
            }
        }

        let cookieValue: string = this.cerbaAuthService.getTokenAuthenticationHeader();
        if (!cookieValue) {
            cookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
            if (!cookieValue) {
                this.redirectWhenNoAuth();
                return false;
            }
        }

        // get user info
        try {
            let user : UserInformations = await this.userInformationsWebService.me().toPromise();
            if (!route.data['withoutInvite'] && user.role == 'INVITE') {
                this.redirectWhenNoAuth();
            } else {
                if (user.modules && user.modules.length > 0 && user.role !== 'ADMINISTRATEUR') {
                    const excludeOldServerResults = false;
                    const hasNewResultServ = user.modules.indexOf('NEW_SERVEUR_RESULTATS') >= 0;
                    user.modules = user.modules.filter(module =>
                        module !== 'SERVEUR_RESULTATS' || !hasNewResultServ || excludeOldServerResults
                    );
                }
                this.userStore.setUser(user);

                if((token == '' || token == null) &&  this.isOriginalAuthentication()){
                    localStorage.setItem(DAYS_BEFORE_EXPIRE_KEY, user.daysBeforeExpire+'');
                    localStorage.setItem(IS_FIRST_CONNECTION_KEY ,user.firstConnection+'');
                }else{
                    localStorage.setItem(DAYS_BEFORE_EXPIRE_KEY, '');
                    localStorage.setItem(IS_FIRST_CONNECTION_KEY ,'');
                }
            }
        } catch (e) {
            console.error("no me.", e);
            this.redirectWhenNoAuth();
            return false;
        }

        // get correspondants
        let correspondants = await this.correspondantWebservice.getCorrespondants().toPromise();
        this.correspondantStore.setCorrespondants(correspondants);

        if (lodash.isEmpty(correspondants)) {
            this.redirectToAccueil();
        }

        if (this.cerbaAuthService.getTokenAuthenticationHeader() != null) {
            cookieValue = this.cerbaAuthService.getTokenCorrespondantHeader();
            if (cookieValue == null) {
                cookieValue = correspondants[0].code;
                this.cerbaAuthService.setTokenCorrespondantHeader(cookieValue);
            }
        } else {
            cookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_CORRESPONDANT);
            if (lodash.isEmpty(cookieValue)) {
                cookieValue = correspondants[0].code;
                this.cookieService.addCoockie(CookieConstantes.COOKIE_CORRESPONDANT, cookieValue);
            }
        }

        if (cookieValue) {
            let selectedCorrespondant = correspondants.find(correspondant => correspondant.code === cookieValue);
            this.correspondantStore.setCorrespondant(selectedCorrespondant);
        } else if (correspondants && correspondants.length > 0) {
            this.correspondantStore.setCorrespondant(correspondants[0]);
        }
        let correspondant = this.correspondantStore.getCorrespondant();
        if (correspondant) {
            if (!this.correspondantStore.hasTag("en") && !this.correspondantStore.hasTag("fr") && !this.correspondantStore.hasTag("fra")) {
                this.redirectToAccueil();
            }
        }

        return true;
    }

    checkIFrame(): boolean {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    valideToken(token: string) {
        token = token.substring(2);
        return this.auth.validateToken({ token: token }).map((a) => {
            //JIRA-261
            this.cerbaAuthService.setTokenAuthenticationHeader(a.cookie);
            if (a.correspondants && a.correspondants.length > 0) {
                this.cerbaAuthService.setTokenCorrespondantHeader(a.correspondants[0].code);
            }
            return true;
        }, () => {
            this.redirectWhenNoAuth();
            return false;
        });
    }

    redirectWhenNoAuth() {
        this.cerbaAuthService.setTokenAuthenticationHeader(null);
        this.cerbaAuthService.setTokenCorrespondantHeader(null);
        this.cerbaAuthService.redirectToLogin();
    }

    extractToken(): string {
        const url = window.location.href.split('?');
        let token: string = null;
        if (url.length >= 2 && this.acceptToken(url[0])) {
            let queryParams = url[url.length - 1];
            let params: string[] = queryParams.split('&');
            token = lodash.find(params, (p) => p.startsWith("t="));
        }
        return token;
    }

    acceptToken(url: string): boolean {
        let accept = false;
        if (url && lodash.includes(url, 'catalogue-examen')) {
            accept = true;
        }
        return accept;
    }


    redirectToAccueil() {
        let domain = this.getDomain(window.location.hostname);
        window.location.href = window.location.protocol + '//www.' + domain;
    }

    getDomain(sN: string) {
        let serverName = sN;
        let serverPaths = serverName.split('.');
        let parts = serverPaths.length;
        if (parts > 1) {
            serverName = serverPaths[parts - 2] + "." + serverPaths[parts - 1];
        }
        return serverName;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/guards/security/cerba-security.guard.ts